// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import messages from './locales'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/reset.css'
Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.config.productionTip = false
const defaultLang = 'zh-CN'
const langToLoaded = Object.keys(messages)

let lang = navigator.language || defaultLang
const i18n = new VueI18n({
  locale: lang,
  messages: messages
})
window.localStorage.setItem('lng-torvandom', lang)
const loadLang = (langToLoad) => {
  if (!~langToLoaded.indexOf(langToLoad)) {
    let localeFetch = import(`./locales/${langToLoad}`)
    return Promise.all([localeFetch]).then((args) => {
      i18n.setLocaleMessage(langToLoad, {...args[0].default, ...(args[1].default)})
    }).catch(() => {
      lang = defaultLang
    })
  }
  return Promise.resolve()
}
let rootIns
Vue.prototype.switchLang = async function (lang) {
  await loadLang(lang)
  i18n.locale = lang
  rootIns.$i18n.locale = lang
  rootIns.$forceUpdate()
}
/* eslint-disable no-new */
loadLang(lang).then(() => {
  i18n.locale = lang
  rootIns = new Vue({
    el: '#app',
    router,
    i18n,
    components: { App },
    template: '<App/>'
  })
})



// WEBPACK FOOTER //
// ./src/main.js